import type { PropsWithChildren } from 'react';
import type { HighlightBoxColor } from './InfoSnippetLong.styles';
import { Wrapper, AccentBlock, Content } from './InfoSnippetLong.styles';

type InfoSnippetLongProps = PropsWithChildren<{ color?: HighlightBoxColor }>;

const InfoSnippetLong = ({ children, color }: InfoSnippetLongProps) => (
  <Wrapper>
    <AccentBlock color={color}>
      <Content>{children}</Content>
    </AccentBlock>
  </Wrapper>
);

export { InfoSnippetLong };
export type { InfoSnippetLongProps };
